import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmps-scorecard-score-container',
    template: `
        <div
            class="scorecard-container"
            [class.single-child]="!hasCategory"
        >
            <div class="scorecard-container-left">
                <ng-content
                    select="[cmps-scorecard-score-section]"
                ></ng-content>
            </div>
            <div
                class="scorecard-container-right"
                *ngIf="hasCategory"
            >
                <ng-content select="[cmps-scorecard-category]"></ng-content>
            </div>
        </div>
    `,
    host: {
        class: 'scorecard-score-container',
    },
})
export class ScorecardScoreContainerComponent {
    @Input() hasCategory: boolean = false;
}
